import { render } from "./StorefrontModal.vue?vue&type=template&id=1c04e515"
import script from "./StorefrontModal.vue?vue&type=script&lang=js"
export * from "./StorefrontModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__